// extracted by mini-css-extract-plugin
module.exports = {"background":"src-components-Page-components-stylesBackgroundImage__background--3owoi","img":"src-components-Page-components-stylesBackgroundImage__img--2280v"};